// READ ME PLEASE:
//     THIS FILE IS A GENERATED. AND SHOULD BE GITIGNORED
//     YOU PROBABLY DO NOT WANT TO ALTER IT. IT'll WASTE YOUR TIME.
//     If it needs changes please set up a model that inherits and overrides
//     the behavior.

import {BaseModel} from '../Core/BaseModel';

import * as validators from '../Core/Validators';

import {
	PasswordsMatchValidator,
	RequiredValidator,
	PasswordRequiredValidator,
	MaxLengthValidator,
	NumericValidator,
	UnsignedNumberValidator,
} from '../Core/Validators';
import {SpeciesType} from './SpeciesType';
import {SpeciesNativity} from './SpeciesNativity';
import {SpeciesInvasivity} from './SpeciesInvasivity';

const _associations = [
			{
				name: 'SpeciesType',
				model: new SpeciesType(),
				type: 'ParentPointer',
				using: 'speciesTypeId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'SpeciesType',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'SpeciesNativity',
				model: new SpeciesNativity(),
				type: 'ParentPointer',
				using: 'speciesNativityId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'SpeciesNativity',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'SpeciesInvasivity',
				model: new SpeciesInvasivity(),
				type: 'ParentPointer',
				using: 'speciesInvasivityId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'SpeciesInvasivity',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
];

const _fieldDefs = [
			{
				title: 'speciesListSpeciesId',
				placeholder: null,
				key: 'speciesListSpeciesId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.speciesListSpeciesId,
				setter: (x, y) => x.speciesListSpeciesId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'speciesListId',
				placeholder: null,
				key: 'speciesListId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.speciesListId,
				setter: (x, y) => x.speciesListId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'speciesId',
				placeholder: null,
				key: 'speciesId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.speciesId,
				setter: (x, y) => x.speciesId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Common Name',
				placeholder: null,
				key: 'commonName',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.commonName,
				setter: (x, y) => x.commonName = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(45),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Scientific Name',
				placeholder: null,
				key: 'latinName',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.latinName,
				setter: (x, y) => x.latinName = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(45),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'speciesTypeId',
				placeholder: null,
				key: 'speciesTypeId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.speciesTypeId,
				setter: (x, y) => x.speciesTypeId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'speciesNativityId',
				placeholder: null,
				key: 'speciesNativityId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.speciesNativityId,
				setter: (x, y) => x.speciesNativityId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'speciesInvasivityId',
				placeholder: null,
				key: 'speciesInvasivityId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.speciesInvasivityId,
				setter: (x, y) => x.speciesInvasivityId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Searchable',
				placeholder: null,
				key: 'searchable',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.searchable,
				setter: (x, y) => x.searchable = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'created',
				placeholder: null,
				key: 'created',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.created,
				setter: (x, y) => x.created = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'modified',
				placeholder: null,
				key: 'modified',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.modified,
				setter: (x, y) => x.modified = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
];

export class ActiveSpeciesListSpecies extends BaseModel {
	constructor() {
		super();
	}

	get groupRenderers() {
		return {
		};
	}

	get recordValidators() {
		return this._recordValidators ?? ( this._recordValidators = [		]);
	}

	get associations() {
		return _associations;
	}
	get fieldDefs() {
		return _fieldDefs;
	}

}
